import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { AddEditEmployeeEmailComponent } from './addEditEmployeeEmail.component';
import { EmployeeEmailConfigService } from '../../../services/index';

@Component({
    selector: 'employee-email-config-tab',
    templateUrl: './employeeEmailList.component.html',
})
export class EmployeeEmailConfigComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public list: any[] = [];
    isLoadMask: Promise<any>;
    isLoading: boolean = false;
    filterData = { search_data: '' };

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'employee_name',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;

    bsModalRef: BsModalRef;

    constructor(private employeeEmailConfigService: EmployeeEmailConfigService, private modalService: BsModalService) { }

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Employee Name', prop: 'employee_name', width: 250, minWidth: 250, maxWidth: 250 },
            { name: 'Email', prop: 'email', width: 300, minWidth: 300, maxWidth: 300 },
            { name: 'Status', prop: 'status', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Action', prop: 'emp_email_id', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];
        this.pageCallback({ offset: 0 });
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (this.suppressPaging) { return; }
        this.page.offset = pageInfo.offset;
        this.getList();
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) { clearTimeout(this.scrollTimeout); }
        this.scrollTimeout = setTimeout(() => { this.suppressPaging = false; }, 100);
    }

    onOpenedFilter(): void {
        setTimeout(function() { $('#filterSearch').focus(); }, 100);
    }

    clearFilter(): void {
        this.filterData = { search_data: '' };
        this.applyFilter();
    }

    applyFilter(): void {
        this.filterPanel.close();
        this.getList();
    }

    getList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        let that = this;
        this.isLoadMask = this.employeeEmailConfigService
            .getList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.list = res.data;
            });
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getList();
    }

    onAddEdit(mode: string, row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditEmployeeEmailComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg maxWidthPer-50'
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = mode + ' Employee Email Config';
        this.bsModalRef.content.rowdata = Object.assign({}, row);
        this.bsModalRef.content.listLoadEvent.subscribe(() => {
            that.getList();
        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/employeeEmailConfig/employeeEmailList.component.ts